/** The festival's mark, as a URL the bundler resolves. */
export const MARK = new URL('../assets/logo-white-transparent.png', import.meta.url).href;
/** The mark in color, for paper — a white mark on a white page is no mark at all. */
export const MARK_COLOR = new URL('../assets/logo-color-transparent.png', import.meta.url).href;
